import component from './kk-KZ/component';
import globalHeader from './kk-KZ/globalHeader';
import menu from './kk-KZ/menu';
import pages from './kk-KZ/pages';
import pwa from './kk-KZ/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';
import messages from './kk-KZ/messages';

export default {
  'navBar.lang': 'Русский',
  'layout.user.link.help': 'Помощь',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.copyright.produced': 'Сделано правильными пацанами',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...messages,
};
